import { render, staticRenderFns } from "./addRegistryModal.vue?vue&type=template&id=648b5ffe&scoped=true&"
import script from "./addRegistryModal.vue?vue&type=script&lang=js&"
export * from "./addRegistryModal.vue?vue&type=script&lang=js&"
import style0 from "./addRegistryModal.vue?vue&type=style&index=0&id=648b5ffe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648b5ffe",
  null
  
)

export default component.exports